import "./projectcreate.css"
function Projectcreate(){
    return(
        <>
        <div className="create">
             <div className="start">
                <h4>Projects Create</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="projectcreate container mt-4 p-4  rounded shadow-sm">

  <h4 className="mb-4 fw-bold">Create New Project</h4>

  <div className="row g-4">

    {/* Project Basic Info */}
    <div className="col-12">
      <h5 className="fw-semibold border-bottom pb-2">Basic Information</h5>
    </div>

    <div className="col-md-6">
      <label className="form-label">Project Name</label>
      <input type="text" className="form-control" placeholder="Enter project name" />
    </div>

    <div className="col-md-6">
      <label className="form-label">Project Category</label>
      <select className="form-select">
        <option>Select Category</option>
        <option>Web Development</option>
        <option>Mobile App</option>
        <option>UI/UX Design</option>
        <option>E-commerce</option>
      </select>
    </div>

    <div className="col-md-6">
      <label className="form-label">Project Type</label>
      <select className="form-select">
        <option>Select Type</option>
        <option>Personal Project</option>
        <option>Team Project</option>
        <option>Client Project</option>
      </select>
    </div>

    <div className="col-md-6">
      <label className="form-label">Project Manager</label>
      <input type="text" className="form-control" placeholder="Assign manager" />
    </div>

    {/* Team Section */}
    <div className="col-12 mt-3">
      <h5 className="fw-semibold border-bottom pb-2">Team & Members</h5>
    </div>

    <div className="col-md-6">
      <label className="form-label">Team Members</label>
      <select className="form-select">
        <option>Select Members</option>
        <option>Ahmed</option>
        <option>Omar</option>
        <option>Sarah</option>
      </select>
    </div>

    <div className="col-md-6">
      <label className="form-label">Access Level</label>
      <select className="form-select">
        <option>Only Admin</option>
        <option>Private (Team Only)</option>
        <option>Public</option>
      </select>
    </div>

    {/* Project Details */}
    <div className="col-12 mt-3">
      <h5 className="fw-semibold border-bottom pb-2">Project Details</h5>
    </div>

    <div className="col-md-4">
      <label className="form-label">Status</label>
      <select className="form-select">
        <option>Planning</option>
        <option>In Progress</option>
        <option>Completed</option>
        <option>On Hold</option>
      </select>
    </div>

    <div className="col-md-4">
      <label className="form-label">Priority</label>
      <select className="form-select">
        <option>Low</option>
        <option>Medium</option>
        <option>High</option>
        <option>Critical</option>
      </select>
    </div>

    <div className="col-md-4">
      <label className="form-label">Budget ($)</label>
      <input type="number" className="form-control" placeholder="Enter budget" />
    </div>

    <div className="col-md-6">
      <label className="form-label">Start Date</label>
      <input type="date" className="form-control" />
    </div>

    <div className="col-md-6">
      <label className="form-label">Deadline</label>
      <input type="date" className="form-control" />
    </div>

    <div className="col-12">
      <label className="form-label">Project Description</label>
      <textarea className="form-control" rows="4" placeholder="Write project details..."></textarea>
    </div>

    {/* Permissions */}
    <div className="col-12 mt-3">
      <h5 className="fw-semibold border-bottom pb-2">Permissions & Notifications</h5>
    </div>

    <div className="col-md-6">
      <div className="form-check">
        <input className="form-check-input" type="checkbox" id="emailNotify" />
        <label className="form-check-label" htmlFor="emailNotify">
          Enable Email Notifications
        </label>
      </div>

      <div className="form-check">
        <input className="form-check-input" type="checkbox" id="taskPermission" />
        <label className="form-check-label" htmlFor="taskPermission">
          Allow Members to Create Tasks
        </label>
      </div>

      <div className="form-check">
        <input className="form-check-input" type="checkbox" id="editPermission" />
        <label className="form-check-label" htmlFor="editPermission">
          Only Admin Can Edit Project
        </label>
      </div>
    </div>

    {/* Buttons */}
    <div className="col-12 text-end mt-4">
      <button className="btn btn-secondary me-2">Cancel</button>
      <button className="btn btn-primary">Create Project</button>
    </div>

  </div>
</div>
        </div>
         <div className="details">
             <div className="start">
                <h4>Projects Detials</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="card shadow-sm mb-4">
  <div className="card-header bg-primary text-white fw-bold">
    Project Details
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-6">
        <label className="form-label">Project Title</label>
        <input type="text" className="form-control" placeholder="Enter project title" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Project Status</label>
        <select className="form-select">
          <option>Planning</option>
          <option>In Progress</option>
          <option>Testing</option>
          <option>Completed</option>
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label">Start Date</label>
        <input type="date" className="form-control" />
      </div>

      <div className="col-md-6">
        <label className="form-label">End Date</label>
        <input type="date" className="form-control" />
      </div>

      <div className="col-12">
        <label className="form-label">Project Description</label>
        <textarea className="form-control" rows="4"></textarea>
      </div>

    </div>
  </div>
</div>
            
    
        </div>
         <div className="setting">
             <div className="start">
                <h4>Projects Settings</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="card shadow-sm mb-4">
  <div className="card-header bg-success text-white fw-bold">
    Project Settings
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-6">
        <label className="form-label">Project Visibility</label>
        <select className="form-select">
          <option>Only Admin</option>
          <option>Private (Team Only)</option>
          <option>Public</option>
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label">Project Priority</label>
        <select className="form-select">
          <option>Low</option>
          <option>Medium</option>
          <option>High</option>
          <option>Critical</option>
        </select>
      </div>

      <div className="col-12">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" />
          <label className="form-check-label">
            Enable Email Notifications
          </label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" />
          <label className="form-check-label">
            Allow Members to Edit Tasks
          </label>
        </div>

        <div className="form-check">
          <input className="form-check-input" type="checkbox" />
          <label className="form-check-label">
            Only Admin Can Edit Project
          </label>
        </div>
      </div>

    </div>
  </div>
</div>
            
    
        </div>
         <div className="Budget">
             <div className="start">
                <h4>Projects Budget</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="card shadow-sm mb-4">
  <div className="card-header bg-dark text-white fw-bold">
    Project Budget
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-4">
        <label className="form-label">Total Budget ($)</label>
        <input type="number" className="form-control" />
      </div>

      <div className="col-md-4">
        <label className="form-label">Spent Amount ($)</label>
        <input type="number" className="form-control" />
      </div>

      <div className="col-md-4">
        <label className="form-label">Remaining Budget ($)</label>
        <input type="number" className="form-control" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Payment Type</label>
        <select className="form-select">
          <option>Fixed Price</option>
          <option>Hourly</option>
          <option>Monthly</option>
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label">Currency</label>
        <select className="form-select">
          <option>USD</option>
          <option>EUR</option>
          <option>EGP</option>
        </select>
      </div>

    </div>
  </div>
</div>
            
    
        </div>
        <div className="assigned">
             <div className="start">
                <h4>Projects Assignesd</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
<div className="card shadow-sm mb-4">
  <div className="card-header bg-info text-white fw-bold">
    Assigned
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-6">
        <label className="form-label">Assign To</label>
        <select className="form-select">
          <option>Select Member</option>
          <option>Ahmed</option>
          <option>Omar</option>
          <option>Sarah</option>
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label">Role</label>
        <select className="form-select">
          <option>Developer</option>
          <option>Designer</option>
          <option>Project Manager</option>
        </select>
      </div>

    </div>
  </div>
</div>
        </div>
        <div className="target">
             <div className="start">
                <h4>Projects Targets</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="card shadow-sm mb-4">
  <div className="card-header bg-primary text-white fw-bold">
    Target
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-6">
        <label className="form-label">Target Percentage (%)</label>
        <input type="number" className="form-control" placeholder="Enter target %" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Target Date</label>
        <input type="date" className="form-control" />
      </div>

    </div>
  </div>
</div>

        </div>
        <div className="completd">
             <div className="start">
                <h4>Projects Completed</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="card shadow-sm mb-4">
  <div className="card-header bg-success text-white fw-bold">
    Completed
  </div>

  <div className="card-body">
    <div className="row g-4">

      <div className="col-md-6">
        <label className="form-label">Completed Percentage (%)</label>
        <input type="number" className="form-control" placeholder="Enter completed %" />
      </div>

      <div className="col-12">
        <label className="form-label">Progress Preview</label>
        <div className="progress">
          <div 
            className="progress-bar bg-success" 
            role="progressbar" 
            style={{ width: "40%" }}
          >
            40%
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

        </div>

        </>
    )
}
export default Projectcreate